import {call, put, select, takeLatest} from 'redux-saga/effects';
import {
    USER_PREFERENCE_UPDATE_START,
    UserPreferenceUpdateStartAction,
    getUserPreferenceUpdateSuccessAction,
    getUserPreferenceUpdateFailedAction
} from "../actions/UserPreferenceAction";
import ApiUtil from "src/utils/ApiUtil";
import RequestStatus from "src/model/RequestStatus";
import GetUserPreferenceResponse from "src/model/UserPreference";
import ApplicationState from "src/model/ApplicationState";

export const getUserPreference = (state: ApplicationState) => state.userPreferenceRes;

export function* setUserPreference(action: UserPreferenceUpdateStartAction) {
    try {
        const userPreferenceResponse: GetUserPreferenceResponse = yield select(getUserPreference);
        const userPreferenceData = (userPreferenceResponse && userPreferenceResponse.requestStatus === RequestStatus.SUCCESS
            && userPreferenceResponse.data) || {};
        const newUserPreferenceData = {...userPreferenceData, ...action.userPreference};
        yield call(ApiUtil.postApiWithTimeout, "setuserpreference", newUserPreferenceData);
        yield put(getUserPreferenceUpdateSuccessAction(newUserPreferenceData));
    } catch (error) {
        console.error("Call API setuserpreference error" + error)
        yield put(getUserPreferenceUpdateFailedAction());
        return;
    }
}

export default function* userPreferenceUpdate() {
    yield takeLatest(USER_PREFERENCE_UPDATE_START, setUserPreference);
}
